<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <!-- <site-device-query :options="filterSites" :query="query" /> -->

    <el-cascader
      ref="cascader"
      v-model="siteDevice"
      size="small"
      :options="filterSites"
      :show-all-levels="false"
      :props="props"
      collapse-tags
      placeholder="请选择站房设备"
      style="width: 240px;"
      @change="onCheck"
    ></el-cascader>

    <!-- <factor-tree-query ref="factor-tree" :factor-tree="filterFactors" :query="query" /> -->

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <dimension-type :default-dimension-type.sync="dimension" @change="onDimensionChanged" />

        <el-checkbox v-model="isMore" size="small" label="多个分组" border />
      </template>

      <trend-related-chart-wrapper-v2
        :data-list="dataList"
        :unit-prop="unitProp"
        :download-name="downloadName"
        :factors="filterFactors"
        :scale="true"
        :site-device="siteDevice"
        :filter-site-map="filterSiteMap"
        :filter-factor-map="filterFactorMap"
        :dimension="dimension"
        :is-more="isMore"
        show-list
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DisplayType from '../../../../components/Data/DisplayType'
import TrendRelatedChartWrapperV2 from '../../../../components/Data/TrendRelatedChartWrapperV2'

export default {
  name: 'StatisticalAnalysisCorrelationAnalysis',
  routeInfo: {
    label: '相关性分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  data: () => ({
    siteDevice: [],
    props: {
      children: 'devices',
      value: 'id',
      label: 'name',
      multiple: true
    },
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    isMore: false
  }),
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, TrendRelatedChartWrapperV2},
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SUN_RADIATION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GREENHOUSE_GAS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PHOTOLYSIS_RATE_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NEGATIVE_OXYGEN_ION_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 2,
    isSetAllFactorIds: () => 2,
    downloadName: () => '站点对比'
  },
  watch: {
    siteDevice () {
      // if (this.siteDevice.length > 5) {
      //   this.time = setTimeout(() => {
      //     this.$message({
      //       type: 'warning',
      //       message: '最多可选择五个',
      //       showClose: true
      //     })
      //   }, 0)
      //   this.siteDevice.splice(-1, 1)
      //   this.$refs.cascader.$refs.panel.clearCheckedNodes()
      // }
    }
  },
  methods: {
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      let {query: {siteIds}} = this

      if (siteIds.length === 0) {
        siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        this.siteDevice = [[filterSites[0].id, filterSites[0].devices[0].id]]
      }

      this.afterSetSiteIds()
    },
    afterSetSiteIds () {
      if (this.setOther()) {
        this.onCheck()
        this.setCurrentQuery()
        this.getData()
      }
    },
    onCheck () {
      let {filterSiteMap, siteDevice} = this

      let factorIds = []
      let sitIds = []
      siteDevice.forEach(el => {
        let siteId = el[0]
        sitIds.push(siteId)

        let siteDevices = filterSiteMap[siteId].devices
        let factors = siteDevices.find(item => item.id === el[1]).siteDeviceFactors
        factorIds.push(factors.map(el => el.factorId))
      })

      this.query.siteIds = [...new Set(sitIds)]
      this.query.factorIds = [...new Set(factorIds.flat())]
    },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    onDimensionChanged () {
      this.formatData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/09CorrelationAnalysis/index.vue